





















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { connectionStateEnum } from "@/const";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "CallStateView",
  components: { BaseButton, BaseAvatar, BaseIcon },
  props: {
    showConnectionError: { type: Boolean, default: false },
    connectionErrorMessage: { type: String, default: "" },
    connectionState: { type: String, default: "" },
    calling: { type: Boolean },
    opponentUser: { type: Object as PropType<UserPublicData>, required: true },
    processingVideoRequest: { type: Boolean, required: true },
    isSmallView: { type: Boolean, default: false },
  },
  setup(props) {
    const { authUserStrict } = useAuthUser();
    const connecting = computed(() => props.connectionState === connectionStateEnum.CONNECTING);

    const disconnect = computed(() => props.connectionState === connectionStateEnum.DISCONNECTED);

    const subtitle = computed(() => {
      if (props.showConnectionError) return $t("Connection lost");
      if (props.processingVideoRequest) return $t("Switching to video chat...");
      return "";
    });

    const caption = computed(() => {
      if (props.connectionErrorMessage && props.showConnectionError) return props.connectionErrorMessage;
      if (props.showConnectionError) return $t("Call ended due to connection error.");
      if (props.processingVideoRequest) return $t("{0} needs to agree to video chat.", [props.opponentUser.screenName]);
      if (props.calling) return $t("Calling...");
      if (connecting.value) return $t("Connecting, please wait...");
      if (disconnect.value) return $t("Not connected");
      return "";
    });

    const buttonText = computed(() => {
      if (props.showConnectionError) return $t("Call back");
      if (props.processingVideoRequest) return $t("Cancel");
      return "";
    });

    const hasAnyText = computed(() => subtitle.value !== "" || caption.value !== "" || buttonText.value !== "");

    const classname = computed(() => {
      if (props.showConnectionError) return "__connection-error";
      if (props.processingVideoRequest) return "__processing-video";
      if (props.calling || connecting.value || disconnect.value) return "d-flex __column __align-center";
      return "";
    });

    const showAvatars = computed(
      () =>
        !props.showConnectionError &&
        (props.processingVideoRequest || props.calling || connecting.value || disconnect.value)
    );

    const showAuthUserAvatar = computed(() => props.processingVideoRequest);

    return { authUserStrict, subtitle, caption, buttonText, classname, showAvatars, hasAnyText, showAuthUserAvatar };
  },
});
